import { useMutation, useQueryClient } from '@tanstack/react-query';
import { showToastV2 } from '@dealstack/frontend/shared/mechanism/toast/useToastV2.tsx';
import { updateMIPPersonalCustomDetails } from '@dealstack/frontend/shared/dataExchange/services/mip.service.ts';
import API_PATHS from '@dealstack/shared/lib/generated/apiPaths.ts';

type UpdateCustomDetailParams = {
	customDetailId: string;
	name: string;
	instruction: string;
	isChecked: boolean;
	triggerInvestorReevaluate?: boolean;
};

export const useUpdateCustomDetail = (mipId?: string, successMessage?: string) => {
	const queryClient = useQueryClient();

	return useMutation({
		mutationFn: (args: UpdateCustomDetailParams) => {
			return updateMIPPersonalCustomDetails(args);
		},
		onSuccess: () => {
			showToastV2({
				title: successMessage,
			});
			return queryClient.invalidateQueries({
				queryKey: [API_PATHS.MIP_CUSTOM_DETAIL_GET, mipId],
			});
		},
	});
};
